import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const AboutHeroSection = ({pageName}) => {
  return (
    <>
      {/* INLINE CSS */}
      <style>{`
        .breadcumb-wrapper {
          position: relative;
          padding: 140px 0 120px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          overflow: hidden;
        }

        .breadcumb-wrapper::before {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.45);
          z-index: 1;
        }

        .breadcumb-wrapper > * {
          position: relative;
          z-index: 2;
        }

        /* Bottom Shape */
        .breadcrumb-bottom-shape {
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          z-index: 3;
        }

        .breadcrumb-bottom-shape img {
          width: 100%;
          display: block;
        }

        /* Floating Shapes */
        .shape-mockup {
          position: absolute;
          z-index: 2;
        }

        .breadcrumb-left {
          left: 80px;
          top: 35%;
        }

        .breadcrumb-right {
          right: 80px;
          top: 30%;
        }

        /* Animations */
        .jump {
          animation: jump 3.5s infinite ease-in-out;
        }

        .jump-reverse {
          animation: jumpReverse 3.5s infinite ease-in-out;
        }

        @keyframes jump {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-18px);
          }
        }

        @keyframes jumpReverse {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(18px);
          }
        }

        /* Content */
        .breadcumb-content {
          text-align: center;
          color: #fff;
        }

        .breadcumb-title {
          font-size: 56px;
          font-weight: 800;
          margin-bottom: 16px;
          line-height: 1.1;
        }

        .breadcumb-menu {
          list-style: none;
          padding: 0;
          margin: 0;
          display: inline-flex;
          gap: 10px;
          align-items: center;
          font-size: 16px;
        }

        .breadcumb-menu li {
          color: #fff;
          font-weight: 500;
        }

        .breadcumb-menu li a {
          color: #7ac142;
          text-decoration: none;
          transition: color 0.25s ease;
        }

        .breadcumb-menu li a:hover {
          color: #ffffff;
        }

        .breadcumb-menu li::after {
          content: "/";
          margin-left: 10px;
          color: rgba(255,255,255,0.6);
        }

        .breadcumb-menu li:last-child::after {
          display: none;
        }

        /* Responsive */
        @media (max-width: 991px) {
          .breadcumb-title {
            font-size: 42px;
          }
          .breadcrumb-left {
            left: 30px;
          }
          .breadcrumb-right {
            right: 30px;
          }
        }

        @media (max-width: 575px) {
          .breadcumb-wrapper {
            padding: 100px 0 90px;
          }
          .breadcumb-title {
            font-size: 32px;
          }
          .breadcrumb-left,
          .breadcrumb-right {
            display: none;
          }
        }
      `}</style>

      {/* BREADCRUMB SECTION */}
      <Box
        className="breadcumb-wrapper background-image shape-mockup-wrap"
        sx={{
          backgroundImage:
            "url('https://html.themehour.net/kleanix/demo/assets/img/bg/breadcrumb-bg.jpg')",
        }}
      >
        {/* Bottom Shape */}
        <Box className="breadcrumb-bottom-shape">
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/bg/breadcrumb-bottom.png"
            alt="shape"
          />
        </Box>

        {/* Left Floating Shape */}
        <Box className="shape-mockup breadcrumb-left jump-reverse">
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/icon/breadcrumb-left.png"
            alt="shape"
          />
        </Box>

        {/* Right Floating Shape */}
        <Box className="shape-mockup breadcrumb-right jump">
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/icon/breadcrumb-right.png"
            alt="shape"
          />
        </Box>

        {/* Content */}
        <Container>
          <Box className="breadcumb-content">
            <Typography component="h1" className="breadcumb-title">
              {pageName}
            </Typography>

            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>{pageName}</li>
            </ul>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default AboutHeroSection;
